import * as APIUtil from '../util/userProfile_util';

export const RECEIVE_USER_PROFILE = 'RECEIVE_USER_PROFILE';
export const REMOVE_USER_PROFILE = 'REMOVE_USER_PROFILE';
export const RECEIVE_USER_PROFILE_ERRORS = 'RECEIVE_USER_PROFILE_ERRORS';

export const receiveUserProfile = (profile) => ({
  type: RECEIVE_USER_PROFILE,
  profile,
});

export const removeUserProfile = (id) => ({
  type: REMOVE_USER_PROFILE,
  id,
});

export const receiveErrors = (errors) => ({
  type: RECEIVE_USER_PROFILE_ERRORS,
  errors,
});

export const fetchUserProfile = (id) => (dispatch) =>
  APIUtil.fetchUserProfile(id)
    .then((res) => dispatch(receiveUserProfile(res.data)))
    .catch((err) => dispatch(receiveErrors(err.response.data)));

export const updateUserProfile = (id, data) => (dispatch) =>
  APIUtil.updateUserProfile(id, data)
    .then((res) => dispatch(receiveUserProfile(res.data)))
    .catch((err) => dispatch(receiveErrors(err.response.data)));

export const deleteUserProfile = (id) => (dispatch) =>
  APIUtil.deleteUserProfile(id)
    .then(() => dispatch(removeUserProfile(id)))
    .catch((err) => dispatch(receiveErrors(err.response.data)));
